import React from "react";
import './Paper.scss'
import Header from "../../../components/Header/Header";
import {lang, language} from "../../../const/language";
import * as actionSpinnerCreator from "../../../store/domain/spinner/action";
import * as actionCreator from "../../../store/domain/classes/action";
import {connect} from "react-redux";
import {withRouter} from "react-router";
import * as classService from "../../../services/class";
import * as courseService from "../../../services/courses";
import * as paperService from "../../../services/papers";
import * as commonFunc from "../../../utils/commonFunc";
import * as constants from "../../../const/constants";
import PaperItems from "../../../components/PaperItems/PaperItemPurchase";
import CardsFooter from "../../../components/Modals/Footers/CardsFooter";
import NotFound from "../../../components/NotFound/NotFound";
import {post} from "jquery";
import moment from "moment";
import ViberHeader from "../../../components/header-new/ViberHeader";

class Papers extends React.Component {
    state = {
        classId: '',
        courseId: '',
        lessons: [],
        papers: [],
        followType: true
    };


    async componentDidMount() {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        this.refs.main.scrollTop = 0;
        console.log(this.props.location.state);
        let data = this.props.location.state;
        if (data.isClass) {
            this.checkClass();
            await this.setState({followType: data.isClass})
        } else {
            this.checkCourse();
            await this.setState({followType: data.isClass})
        }
    }

    checkCourse = async () => {
        let state = this.props.location.state;

        console.log(state.id);
        if (state) {
            this.props.spinnerHandler({isSpin: true, type: 10});
            await courseService.searchCourse(state.id)

                .then(async response => {
                    //console.log(response)
                    if (response.success) {
                        await this.setState({courseId: response.body.courseId});
                        // this.props.selectClassHandler(response.body);
                        await this.getAllPapers();
                    } else {
                        this.props.spinnerHandler(false);
                        commonFunc.notifyMessage(response.message, response.status);
                        this.goHome();
                    }
                })
        } else {
            this.goHome();
        }
    };


    checkClass = async () => {
        let state = this.props.location.state;
        console.log(this.props.location.state);
        if (state) {
            this.props.spinnerHandler({isSpin: true, type: 10});
            await classService.getClassDetailsById(state.id)
                .then(async response => {
                    if (response.success) {
                        await this.setState({classId: response.body.id});
                        this.props.selectClassHandler(response.body);
                        await this.getAllPapers();
                    } else {
                        this.props.spinnerHandler(false);
                        commonFunc.notifyMessage(response.message, response.status);
                        this.goHome();
                    }
                })
        } else {
            this.goHome();
        }
    };

    goHome = () => {
        this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_INSTITUTE_ROUTE}`)
    };

    onBack = () => {
        window.history.back();
    };

    getAllPapers = async () => {
        let state = this.props.location.state;
        let newDate = new Date();

        if (this.state.followType) {
            const data = {
                "classId": this.state.classId,
                "studentEnrollMonth": moment(newDate).format('MMMM').toUpperCase(),
                "studentId": this.props.userObj.id,
                "quizEnrollMonth": Number(moment(newDate).format('MM')),
            };
            //console.log(data)
            await paperService.getAllPapersByClass(data)
                .then(res => {
                    this.props.spinnerHandler(false);
                    if (res.success) {
                        //console.log(res.body)
                        this.setState({
                            papers: res.body,
                        });
                        //console.log(this.state.papers)
                    } else {
                        commonFunc.notifyMessage(res.message);
                    }
                })
                .catch(error => {
                    this.props.spinnerHandler(false);
                    commonFunc.notifyMessage(error.message, error.status);
                })
        } else {
            let courseId = this.state.courseId;
            console.log(courseId);
            await paperService.getAllPapersByCourse(courseId)
                .then(res => {
                    this.props.spinnerHandler(false);
                    if (res.success) {
                        console.log(res.body);
                        this.setState({
                            papers: res.body,
                        });
                        //console.log(this.state.papers)
                    } else {
                        commonFunc.notifyMessage(res.message);

                    }

                })
                .catch(error => {
                    this.props.spinnerHandler(false);
                    commonFunc.notifyMessage(error.message, error.status);
                })


        }
    };

    render() {
        let {selectClass} = this.props;
        return (
            <div>
                {/*<Header/>*/}
                <ViberHeader/>
                <main ref="main" className={"papers"}>
                    <div className="paper-intro">
                        <button className={"home-btn"}
                                onClick={() => this.onBack()}>
                            <i className="icofont-long-arrow-left"/>
                            {language[lang].BackToTour}
                        </button>
                    </div>
                    <div className="trapezoid "></div>
                    {
                        selectClass &&

                        <div className='ml-3 mr-3'>
                            <p className={"head-topic"}>{`${selectClass.name} - ${selectClass.subject}`}</p>
                            <p className={"head-teacher"}> by {`${this.props.selectClass.teacher.teacherName}`}</p>
                        </div>

                    }

                    {
                        this.state.papers.length === 0 &&
                        <NotFound/>
                    }


                    <PaperItems papers={this.state.papers}
                                id={this.state.followType ? this.state.classId : this.state.courseId}
                    flowType={this.state.followType}
                    />

                </main>
                <CardsFooter/>
            </div>
        )
    }
}


const mapStateToProps = (state) => ({
    selectClass: state.classes.selectClass,
    userObj: state.student.userObj
});
const mapDispatchToProps = (dispatch) => ({
    selectClassHandler: data => dispatch(actionCreator.selectClass(data)),
    spinnerHandler: data => dispatch(actionSpinnerCreator.spinnerHandler(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Papers));

/* Created By Janitha Prashad Katukenda
 jpk Created on Thu Dec 10 2020
Copyright (c) 2020 Ceyentra Technologies
EDULAB */

